<template>
  <div class="view-container">
    <div class="app-container">
    <form class="register_form">
        <input name="BotCheck" type="text" class="form-control" hidden required/>
        <label>First Name</label><br>
        <input name="FirstName" type="text" value="" class="form-control" placeholder="John" required>
        <label>Last Name</label><br>
        <input name="LastName" type="text" value="" class="form-control" placeholder="Doe" required>
        <label>Mobile</label>
        <input name="Mobile" type="text" value="" class="form-control" placeholder="0821234567" required>
        <label>Email</label>
        <input name="Email" type="text" value="" class="form-control" placeholder="johndoe@gmail.com" required>
        <button class="btn register_submit" :style="{ 'background-color': accentColor }">
            Register
        </button>
        <router-link to="/login">
            <p style="color:#275a86">Already have an account?</p>
        </router-link>
    </form>

</div>
  </div>
</template>
<!-- Scripts -->
<script>
import { view } from "./Register.vue.js";

export default {
  name: "Register",
  components: {
  },
  mixins: [view],
  data() {
    return {}
  },
  computed: {
      accentColor: function () {
        return this.$franchiseAccentColor;
      }
  },
  created() {
  },
  mounted() {
    document.querySelector('button.register_submit').addEventListener("click", this.submit);
  }
};
</script>
<style>
    @import './Register.vue.css'; 
</style>
